// Buffer polyfill for @ton/core — must execute before main.tsx module graph
// Loaded as a separate entry point in index.html to guarantee execution order

import { Buffer } from 'buffer';
globalThis.Buffer = Buffer;
